import GlobalStyles from './Styles/GlobalStyles';
import Layout from './Components/Layout';

function App() {
  return (
    <>
    <Layout /> 
    <GlobalStyles />
    </>
  );
}

export default App;
